import { render, staticRenderFns } from "./HeroPlaceholder.vue?vue&type=template&id=b01175c6"
import script from "./HeroPlaceholder.vue?vue&type=script&lang=js"
export * from "./HeroPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports